import * as React from 'react';
import { ConditionLabelModel } from './ConditionLabelModel';
import { ConditionLabelWidget } from './ConditionLabelWidget';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
import { DiagramEngine } from '@projectstorm/react-diagrams-core';

export class ConditionLabelFactory extends AbstractReactFactory<ConditionLabelModel, DiagramEngine> {
	constructor() {
		super('conditionLabel');
	}

	generateReactWidget(event: any): JSX.Element {
		return <ConditionLabelWidget model={event.model} />;
	}

	generateModel(event: any): ConditionLabelModel {
		return new ConditionLabelModel();
	}
}